var sb = require('@sb/util')

export default {
	props: ['buttons'],

	render () {
		if (sb.size(this.buttons) === 0) return null
		var $buttons = sb.map(this.buttons, (button, index) => {
			if (button.type === 'call_button') {
				return (
					<a class="url-button-attachment" href={'tel:' + button.phone_number} key={index} title={button.title}>
						{button.title}
					</a>
				)
			}

			if (button.type === 'url_button') {
				return (
					<a class="url-button-attachment" href={button.url} target="_blank" key={index} title={button.title}>
						{button.title || button.url}
					</a>
				)
			}

			if (button.type === 'widget_ask_desktop_notify_button') {
				return null
			}

			if (button.type === 'widget_ask_contact_info_button') {
				return (
					<a class="url-button-attachment" key={index} vOn:click_stop={this.openSetting} title={button.title}>
						{this.$t('btn_ask_save_info') || button.title}
					</a>
				)
			}
			return null
		})

		return <div class="button-attachments">{$buttons}</div>
	},
}
